import styled from "styled-components"
import { Link } from "react-router-dom"
import { P } from "../typography"

export const Container = styled.div`
  display: flex;
  width: 120px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`

export const Metric = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
`

export const Title = styled.div``

export const StyledP = styled(P)`
  font-size: 14px;
`

export const StatLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`
